import React from 'react';
import PropTypes from 'prop-types';
import Request from '../../../services/request';
import Notifications from '../../../services/notifications';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import JourneyStepProp from '../propTypes/journeyStepProp';

function JourneyStepDone({ t, _csrf, step, onDone }) {
  const handleDone = () => {
    new Request(_csrf)
      .post(`/journey/step/${step._id}/done`)
      .done(() => {
        Notifications.showNotificationSuccess(
          t('success'),
          t('journey_stepDone'),
        );
        onDone();
      })
      .fail(err => {
        Notifications.showErrorFromRequest(err, 'error_stepDone');
      });
  };

  return (
    <div className="m-portlet m-portlet-rounded">
      <div className="m-portlet__body">
        <div className="row">
          <div
            className="col-12 task-description"
            style={{ textAlign: 'center' }}
          >
            {t('journey_stepIsComplete')}
          </div>
        </div>
        <div className="mark-done-container">
          <button
            type="button"
            className="btn m-btn btn-dynamic loader-button"
            onClick={handleDone}
          >
            <i
              className="la la-check"
              style={{ marginRight: '5px', marginBottom: '5px' }}
            />
            {t('journey_markAsDone')}
          </button>
        </div>
      </div>
    </div>
  );
}

JourneyStepDone.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onDone: PropTypes.func.isRequired,
};

export default compose(
  translate,
  withCSRF,
)(JourneyStepDone);
